/**
 * Created by Administrador on 25/04/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {

        $stateProvider
            .state('classAvailabilityByFlight', {
                parent: 'app',
                url: '/classAvailabilityByFlight',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/classAvailability/classAvailability.html',
                        controller: 'classAvailabilityCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['classAvailability']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabClassAvailability('classAvailabilityByFlight')
                            }],
                            type: [function () {
                                return 'flight';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('classAvailabilityByConnection', {
                parent: 'app',
                url: '/classAvailabilityByConnection',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/classAvailability/classAvailability.html',
                        controller: 'classAvailabilityCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['classAvailability']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabClassAvailability('classAvailabilityByConnection')
                            }],
                            type: [function () {
                                return 'connection';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            });
    }
})();
